export const Regexes = {
    OnlyNumeric:/^[0-9\b]+$/,
    DecimalAndNumeric:/^(0|[1-9]\d*)(\.\d+)?$/,
    onlyUPIid:/^[a-zA-Z0-9.\-_]{2,49}@[a-zA-Z._]{2,49}$/,
    GST:/^([0][1-9]|[1-2][0-9]|[3][0-7])([A-Z]{5})([0-9]{4})([A-Z]{1}[1-9A-Z]{1})([Z]{1})([0-9A-Z]{1})+$/,
    AlphaNumeric:/^[A-Za-z0-9]+$/
}